import React, { useState } from 'react';
interface Tab {
  id: string;
  label: string;
  content: React.ReactNode;
}
interface TabsProps {
  tabs: Tab[];
  defaultTab?: string;
}
export function Tabs({
  tabs,
  defaultTab
}: TabsProps) {
  const [activeTab, setActiveTab] = useState(defaultTab || tabs[0]?.id);
  return <div data-id="element-155">
      <div className="border-b border-gray-200" data-id="element-156">
        <nav className="-mb-px flex space-x-8" aria-label="Tabs" data-id="element-157">
          {tabs.map(tab => <button key={tab.id} onClick={() => setActiveTab(tab.id)} className={`
                whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm transition-colors
                ${activeTab === tab.id ? 'border-bulog-blue text-bulog-blue' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}
              `} data-id="element-158">
              {tab.label}
            </button>)}
        </nav>
      </div>
      <div className="mt-6" data-id="element-159">
        {tabs.find(t => t.id === activeTab)?.content}
      </div>
    </div>;
}